/* eslint-disable @typescript-eslint/no-explicit-any */

export interface IAction<T = any> {
  type: string;
  value: T;
}

const reducerFactory = <S>(
  state: S,
  action: IAction,
  handlers: {
    [x: string]: (state: S, action: any) => S;
  },
): S => {
  const handler = handlers[action.type];

  return handler ? handler(state, action) : state;
};

export default reducerFactory;
